import { render, staticRenderFns } from "./Docs_editor.vue?vue&type=template&id=04ce7719"
import script from "./Docs_editor.vue?vue&type=script&lang=js"
export * from "./Docs_editor.vue?vue&type=script&lang=js"
import style0 from "./Docs_editor.vue?vue&type=style&index=0&id=04ce7719&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports